
export const SITE_CONTENT = {
  common: {
    appName: "ErsteHilfe2Go",
    tagline: "Erste Hilfe lernen – bevor man sie braucht.",
    contactEmail: "hallo@erstehilfe2go.de",
    social: {
      instagram: "https://www.instagram.com/erstehilfe2go",
      linkedin: "https://www.linkedin.com/company/erstehilfe2go",
    }
  },
  home: {
    hero: {
      badge: "Pre-Launch Phase: Entwicklung in vollem Gange",
      headline: "Erste Hilfe lernen –",
      headlineItalic: "bevor man sie braucht.",
      description: "Die moderne Erste-Hilfe-Lernapp für Deutschland. Aktuell in Entwicklung – bald verfügbar.",
      ctaPrimary: "Jetzt auf die Warteliste setzen",
      ctaSecondary: "Mehr erfahren",
      microcopy: ["✓ Kostenlos & unverbindlich", "✓ Kein Spam", "✓ Jederzeit abmeldbar"]
    },
    whySection: {
      headline: "Im Notfall zählt jede Sekunde –",
      headlineItalic: "nicht Google.",
      description: "Viele Menschen wissen theoretisch, was zu tun wäre. Doch im Ernstfall fehlt oft die Sicherheit. ErsteHilfe2Go hilft dir dabei, dieses Wissen regelmäßig aufzufrischen.",
    }
  },
  waitlist: {
    headline: "Sei beim Start dabei",
    description: "Trage dich jetzt unverbindlich in unsere Warteliste ein und erhalte alle Informationen direkt in dein Postfach.",
    ctaForm: "Jetzt auf die Warteliste setzen",
    successTitle: "Fast geschafft!",
    successMessage: "Bitte klicke auf den Link in der Bestätigungs-Mail, die wir dir gerade gesendet haben.",
  },
  newsletter: {
    headline: "Bleib informiert!",
    description: "Trage dich hier ein, um regelmäßig Neuigkeiten über ErsteHilfe2Go zu erhalten. Du erfährst alles zum Release, neuen Lektionen und Möglichkeiten, aktiv mitzuhelfen.",
    cta: "Newsletter abonnieren",
    successTitle: "Anmeldung fast fertig!",
    successMessage: "Wir haben dir eine E-Mail gesendet. Bitte bestätige deine Anmeldung über den Link in der Mail (Double-Opt-In).",
    microcopy: "✓ Kostenlos & unverbindlich  ✓ Jederzeit abmeldbar"
  },
  images: {
    heroMockup: "https://images.unsplash.com/photo-1516574187841-cb9cc2ca948b?auto=format&fit=crop&q=80&w=800",
    blogPlaceholder: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80&w=800",
  },
  features: [
    {
      title: 'Interaktive Lernpfade',
      desc: 'Gamified Learning für maximale Motivation. Schalte Level frei und sammle Erfolge.',
      icon: '🎮',
      status: 'In Entwicklung',
      bg: 'bg-blue-50',
      benefit: ''
    },
    {
      title: 'Forum',
      desc: 'Du hast eine Frage zum Thema Erste-Hilfe? Die Experten in unserer Community stehen dir zur Seite!',
      icon: '💬',
      status: 'In Planung',
      bg: 'bg-red-50',
      benefit: ''
    },
    {
      title: 'Tages-Challenges',
      desc: 'Kurze Wissens-Snacks für den täglichen Aha-Effekt und langfristiges Behalten.',
      icon: '📅',
      status: 'In Entwicklung',
      bg: 'bg-amber-50',
      benefit: ''
    }
  ]
};
